// src/App.jsx
import React, { useEffect, useState } from "react";
import LandingPage from "./components/LandingPage";
import ModernDashboard from "./components/ModernDashboard";
import ModernRegisterWill from "./components/ModernRegisterWill";
import BeneficiaryDashboard from "./components/BeneficiaryDashboard";
import { validateConfig } from "./config";

const App = () => {
  const [currentView, setCurrentView] = useState('landing'); // 'landing', 'dashboard', 'register', 'beneficiary'

  // Initialize configuration on app start
  useEffect(() => {
    const isValid = validateConfig();
    if (!isValid) {
      console.error('❌ Configuration validation failed. Please check your environment variables.');
    }
  }, []);

  const renderView = () => {
    switch (currentView) {
      case 'landing':
        return (
          <LandingPage 
            onGetStarted={() => setCurrentView('dashboard')} 
            onBeneficiaryLogin={() => setCurrentView('beneficiary')}
          />
        );
      case 'dashboard':
        return <ModernDashboard onRegisterClick={() => setCurrentView('register')} />;
      case 'register':
        return <ModernRegisterWill onBack={() => setCurrentView('dashboard')} />;
      case 'beneficiary':
        return <BeneficiaryDashboard onBackToHome={() => setCurrentView('landing')} />;
      default:
        return (
          <LandingPage 
            onGetStarted={() => setCurrentView('dashboard')} 
            onBeneficiaryLogin={() => setCurrentView('beneficiary')}
          />
        );
    }
  };

  return (
    <div className="min-h-screen">
      {renderView()}
    </div>
  );
};

export default App;
